/**
 * Environment configuration — everything comes in as VITE_ variables,
 * populated from Azure Key Vault (`pnpm env:load`) or, for local Docker
 * dev, from `pnpm dev:storage:init` against Azurite.
 */
export const environment = {
  name: import.meta.env.VITE_ENVIRONMENT ?? 'dev',
  azureAd: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID ?? '',
    tenantId: import.meta.env.VITE_AZURE_AD_TENANT_ID ?? '',
  },
  storage: {
    blobEndpoint: (import.meta.env.VITE_AZURE_STORAGE_BLOB_ENDPOINT ?? '').replace(/\/$/, ''),
    /** Local-dev only (Azurite). Empty in test/live where Entra ID tokens are used. */
    sas: import.meta.env.VITE_AZURE_STORAGE_SAS ?? '',
    contentContainer: 'site-content',
    mediaContainer: 'media',
    /** Private container — portal settings incl. the LLM API key. */
    portalContainer: 'portal',
    /** Private container — contact-form inquiries, written by /api/contact. */
    submissionsContainer: 'submissions',
  },
} as const;

export const isAuthConfigured = (): boolean =>
  Boolean(environment.azureAd.clientId && environment.azureAd.tenantId);

export const isStorageConfigured = (): boolean => Boolean(environment.storage.blobEndpoint);
